const UPPY_CONFIG = {
  id: 'uploader',
  autoProceed: false,
  debug: true,
}

export default UPPY_CONFIG
